<template>
  <div class="container">
    <div class="sc-message--text" :style="messageColors">
      <p class="sc-message--text-content" v-html="messageText"></p>
      <div class="certificado-container">
        <a :href="message.data.metadata.certificado" class="button" target="_blank" :style="{ backgroundColor: chatbotColors.sentMessage.bg, color: chatbotColors.sentMessage.text }">
          <img src="data:image/png;base64,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"> Baixar Certificado
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import escapeGoat from 'escape-goat'
import store from './../store/'

export default {
  props: {
    message:{
      type: Object,
      required: true
    },
    messageColors: {
      type: Object,
      required: true
    },
    messageStyling: {
      type: Boolean,
      required: true
    },
    chatbotColors: {
      type: Object,
      required: true
    },
    lastMessage: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      store,
    }
  },
  computed: {
    messageText() {
      const escaped = this.me
        ? escapeGoat.escape(this.message.data.text)
        : this.message.data.text;

      return escaped;
    }
  },
}
</script>

<style scoped>
  .container {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
  }
  .certificado-container {
    display: flex;
  }
  .button {
    display: flex;
    align-items: center;
    margin: 10px 5px 5px 0;
    padding: 10px 15px;
    border-radius: 5px;
    font-size: 14px;
    line-height: 1.4;
    position: relative;
    -webkit-font-smoothing: subpixel-antialiased;
    border: 0;
    text-decoration: none;
    background: #445a64;
    color: #fff;
  }
  .button:hover {
    opacity: .8;
  }
  .button img {
    width: 25px;
    margin-right: 10px;
  }
</style>
